import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=2cba4bd0&scoped=true&"
import script from "./Client.vue?vue&type=script&lang=js&"
export * from "./Client.vue?vue&type=script&lang=js&"
import style0 from "./Client.vue?vue&type=style&index=0&id=2cba4bd0&scoped=true&lang=css&"
import style1 from "./Client.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cba4bd0",
  null
  
)

export default component.exports